(() => {
  const root = document.querySelector('.k3lp-root');
  if (!root || root.dataset.enhanced) return;
  root.dataset.enhanced = 'true';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const AUTO_MS = 7500;   // testimonials: time on each card before auto-advance (7–8s)
  const PAUSE_MS = 8000;  // after any manual interaction, hold off auto-advance this long

  // Real (non-clone) cards. Review tracks get CLONES clones of each edge so the carousel is endless.
  const CLONES = 3;
  const allCards = (track) => Array.from(track.children).filter(el => el.matches('article, .k3lp-product, .k3lp-review'));
  const cardsOf = (track) => allCards(track).filter(el => !el.hasAttribute('data-clone'));
  const isLoop = (track) => track.classList.contains('k3lp-review-track');
  const setupLoop = (track) => {
    const cards = cardsOf(track);
    if (!isLoop(track) || cards.length < 2 || track.dataset.loop) return;
    track.dataset.loop = 'true';
    const k = Math.min(CLONES, cards.length);
    cards.slice(0, k).forEach(c => { const d = c.cloneNode(true); d.setAttribute('data-clone', 'head'); d.setAttribute('aria-hidden', 'true'); d.querySelectorAll('[id]').forEach(e => e.removeAttribute('id')); d.querySelectorAll('button,[href]').forEach(e => e.setAttribute('tabindex', '-1')); track.appendChild(d); });
    cards.slice(-k).reverse().forEach(c => { const d = c.cloneNode(true); d.setAttribute('data-clone', 'tail'); d.setAttribute('aria-hidden', 'true'); d.querySelectorAll('[id]').forEach(e => e.removeAttribute('id')); d.querySelectorAll('button,[href]').forEach(e => e.setAttribute('tabindex', '-1')); track.prepend(d); });
    // start on the first real card (after the leading clones) without animating
    const pad = parseFloat(getComputedStyle(track).scrollPaddingInlineStart || getComputedStyle(track).scrollPaddingLeft) || 0;
    track.dataset.programmatic = String(Date.now());
    track.scrollTo({ left: cards[0].offsetLeft - track.offsetLeft - pad, behavior: 'auto' });
  };
  // Index of the real card whose twin (real or clone) is nearest the snap position; also returns that element.
  const nearest = (track) => {
    const all = allCards(track), cards = cardsOf(track);
    const rect = track.getBoundingClientRect();
    const left = rect.left + (parseFloat(getComputedStyle(track).scrollPaddingInlineStart || getComputedStyle(track).scrollPaddingLeft) || 0);
    let best = null, dist = Infinity;
    all.forEach(el => { const d = Math.abs(el.getBoundingClientRect().left - left); if (d < dist) { dist = d; best = el; } });
    if (!best) return { index: 0, el: null };
    const n = cards.length;
    if (!best.hasAttribute('data-clone')) return { index: cards.indexOf(best), el: best };
    const pos = all.indexOf(best);
    const k = all.length === n ? 0 : (all.length - n) / 2;
    return { index: ((pos - k) % n + n) % n, el: best };
  };
  const activeIndex = (track) => nearest(track).index;
  const scrollToEl = (track, el, smooth) => {
    const pad = parseFloat(getComputedStyle(track).scrollPaddingInlineStart || getComputedStyle(track).scrollPaddingLeft) || 0;
    const max = track.scrollWidth - track.clientWidth;
    track.dataset.programmatic = String(Date.now());
    track.scrollTo({ left: Math.min(el.offsetLeft - track.offsetLeft - pad, max), behavior: smooth && !reduced ? 'smooth' : 'auto' });
  };
  // Move to logical card `index`. In loop tracks a step off either end animates onto the adjacent CLONE so the
  // motion is continuous; once that scroll settles we snap (instantly) to the real twin.
  const goTo = (track, index, fromIndex) => {
    const cards = cardsOf(track);
    if (!cards.length) return;
    const N = cards.length;
    const n = ((index % N) + N) % N;
    let target = cards[n];
    if (isLoop(track) && track.dataset.loop && fromIndex !== undefined) {
      const all = allCards(track), k = (all.length - N) / 2;
      if (fromIndex === N - 1 && n === 0) target = all[k + N];          // 10 -> 1 : first head clone
      else if (fromIndex === 0 && n === N - 1) target = all[k - 1];     // 1 -> 10 : last tail clone
    }
    track.dataset.target = String(n);
    scrollToEl(track, target, true);
    paint(track, n);
  };
  // After any scroll settles on a clone, jump to the real card so there is always room to keep going.
  const settleLoop = (track) => {
    if (!isLoop(track) || !track.dataset.loop) return;
    const { index, el } = nearest(track);
    if (el && el.hasAttribute('data-clone')) scrollToEl(track, cardsOf(track)[index], false);
  };
  const scrollTrack = (track, direction) => {
    if (!track) return;
    const current = track.dataset.target !== undefined && Number(track.dataset.target) >= 0 ? Number(track.dataset.target) : activeIndex(track);
    goTo(track, current + direction, current);
  };
  // Dots + "n of N" counter for each scrolling track
  const paint = (track, index) => {
    const id = track.id;
    const cards = cardsOf(track);
    const dots = root.querySelector('[data-k3lp-dots="' + id + '"]');
    const count = root.querySelector('[data-k3lp-count="' + id + '"]');
    if (dots && dots.children.length !== cards.length) {
      dots.innerHTML = '';
      cards.forEach((card, i) => {
        const b = document.createElement('button');
        b.type = 'button'; b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Go to card ' + (i + 1) + ' of ' + cards.length);
        b.dataset.k3lpDot = String(i);
        dots.appendChild(b);
      });
    }
    if (dots) Array.from(dots.children).forEach((b, i) => b.setAttribute('aria-selected', i === index ? 'true' : 'false'));
    if (count) count.textContent = (index + 1) + ' of ' + cards.length;
  };
  const tracks = Array.from(root.querySelectorAll('.k3lp-review-track, .k3lp-products'));
  tracks.forEach(track => {
    setupLoop(track);
    paint(track, 0);
    let raf = 0, settle = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf); clearTimeout(settle);
      raf = requestAnimationFrame(() => {
        const ours = Date.now() - Number(track.dataset.programmatic || 0) < 900;
        if (!ours) { const i = activeIndex(track); track.dataset.target = String(i); paint(track, i); }
      });
      // 'scroll' stops firing when the scroll (ours or the user's swipe) has settled
      settle = setTimeout(() => settleLoop(track), 120);
    }, { passive: true });
  });
  addEventListener('resize', () => tracks.forEach(track => { settleLoop(track); paint(track, activeIndex(track)); }));


  // Kit gallery: N thumbnails drive one main image; arrows + counter wrap around.
  let galleryIndex = 0;
  const showGallery = (i) => {
    const thumbs = Array.from(root.querySelectorAll('.k3lp-thumbs [data-k3lp-gallery]'));
    const main = root.querySelector('.k3lp-kit-main'), count = root.querySelector('.k3lp-gal-count');
    if (!thumbs.length || !main) return;
    galleryIndex = ((i % thumbs.length) + thumbs.length) % thumbs.length;
    const t = thumbs[galleryIndex];
    main.src = t.dataset.full; main.alt = t.dataset.alt || '';
    thumbs.forEach((b, k) => { b.classList.toggle('is-active', k === galleryIndex); b.setAttribute('aria-pressed', k === galleryIndex ? 'true' : 'false'); });
    if (count) count.textContent = (galleryIndex + 1) + ' of ' + thumbs.length;
    // keep the active thumb visible inside the rail without scrolling the page
    const rail = t.parentElement;
    const target = t.offsetLeft - (rail.clientWidth - t.offsetWidth) / 2;
    rail.scrollTo({ left: Math.max(0, target), behavior: reduced ? 'auto' : 'smooth' });
  };
  // Manual only: the product gallery never autoplays. Swipe/drag on the stage steps prev/next (wraps at both ends).
  const stage = root.querySelector('.k3lp-gallery-stage');
  if (stage) {
    let x0 = null, y0 = null;
    stage.addEventListener('dragstart', (e) => e.preventDefault());
    stage.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse' && e.button !== 0) return; x0 = e.clientX; y0 = e.clientY; try { stage.setPointerCapture(e.pointerId); } catch (_) {} }, { passive: true });
    stage.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0, dy = e.clientY - y0; x0 = y0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) showGallery(galleryIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });
    stage.addEventListener('pointercancel', () => { x0 = y0 = null; }, { passive: true });
    stage.style.touchAction = 'pan-y';
    const galRoot = root.querySelector('[data-k3lp-gallery-root]');
    galRoot && galRoot.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); showGallery(galleryIndex + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); showGallery(galleryIndex - 1); } });
    showGallery(0);
  }

  // Testimonial "Read More": open a stable accessible dialog; cards never expand vertically.
  let lastReviewTrigger = null;
  const reviewModal = root.querySelector('[data-k3lp-review-modal]');
  const reviewDialog = reviewModal && reviewModal.querySelector('.k3lp-review-dialog');
  const closeReviewModal = () => {
    if (!reviewModal || reviewModal.hidden) return;
    reviewModal.hidden = true; reviewModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('k3lp-modal-open');
    if (lastReviewTrigger) { lastReviewTrigger.setAttribute('aria-expanded', 'false'); lastReviewTrigger.focus({ preventScroll: true }); lastReviewTrigger = null; }
  };
  const openReviewModal = (trigger) => {
    if (!reviewModal || !reviewDialog) return;
    let card = trigger.closest('.k3lp-review');
    // Loop clones are visible copies of real cards; open the real twin's review.
    if (card && card.hasAttribute('data-clone')) {
      const track = card.closest('.k3lp-review-track');
      const all = track ? Array.from(track.children).filter(el => el.matches('.k3lp-review')) : [];
      const real = all.filter(el => !el.hasAttribute('data-clone'));
      const k = (all.length - real.length) / 2;
      const pos = all.indexOf(card); const n = real.length;
      card = real[((pos - k) % n + n) % n] || card;
    }
    const full = card && card.querySelector('.k3lp-review-full');
    const excerpt = card && card.querySelector('.k3lp-review-excerpt');
    const by = card && card.querySelector('.k3lp-review-by');
    if (!card || !full) return;
    const body = reviewModal.querySelector('[data-k3lp-modal-body]');
    const stars = reviewModal.querySelector('[data-k3lp-modal-stars]');
    const modalBy = reviewModal.querySelector('[data-k3lp-modal-by]');
    body.innerHTML = full.innerHTML.replace(/<button[\s\S]*?<\/button>/gi, '');
    stars.innerHTML = card.querySelector('.k3lp-stars')?.innerHTML || '★★★★★';
    modalBy.innerHTML = by ? by.innerHTML : '';
    reviewModal.hidden = false; reviewModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('k3lp-modal-open'); lastReviewTrigger = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    reviewModal.querySelector('button[data-k3lp-review-close]').focus();
  };
  if (reviewModal) {
    reviewModal.addEventListener('click', (e) => { if (e.target.closest('[data-k3lp-review-close]')) closeReviewModal(); });
    reviewModal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); closeReviewModal(); return; }
      if (e.key !== 'Tab') return;
      const f = Array.from(reviewDialog.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])')).filter(x => !x.disabled);
      if (!f.length) return; const first=f[0], last=f[f.length-1];
      if (e.shiftKey && document.activeElement===first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement===last) { e.preventDefault(); first.focus(); }
    });
  }
  const anyExpanded = () => null;
  root.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-k3lp-scroll]');
    if (arrow) {
      const track = root.querySelector('#' + arrow.dataset.k3lpScroll);
      scrollTrack(track, Number(arrow.dataset.direction));
      track && (track.dataset.pauseUntil = String(Date.now() + PAUSE_MS));
    }
    const dot = event.target.closest('[data-k3lp-dot]');
    if (dot) {
      const track = root.querySelector('#' + dot.parentElement.dataset.k3lpDots);
      if (track) { goTo(track, Number(dot.dataset.k3lpDot)); track.dataset.pauseUntil = String(Date.now() + PAUSE_MS); }
    }
    const thumb = event.target.closest('[data-k3lp-gallery]');
    if (thumb) showGallery(Array.prototype.indexOf.call(thumb.parentElement.children, thumb));
    const step = event.target.closest('[data-k3lp-gal-step]');
    if (step) showGallery(galleryIndex + Number(step.dataset.k3lpGalStep));
    const more = event.target.closest('[data-k3lp-read-more]');
    if (more) { event.preventDefault(); openReviewModal(more); }
    const less = event.target.closest('[data-k3lp-read-less]');
    if (less) { event.preventDefault(); closeReviewModal(); }
    const add = event.target.closest('.k3lp-add');
    if (add) addToCart(add);
  });

  // Capture Read More before the moving review track can intercept the pointer.
  root.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-k3lp-read-more]');
    if (trigger) { event.preventDefault(); event.stopPropagation(); openReviewModal(trigger); }
  }, true);

  // Purchase type -> CTA + selling plan
  const syncOffer = () => {
    const checked = root.querySelector('[name="k3lp-offer"]:checked');
    root.querySelectorAll('.k3lp-offer').forEach(offer => offer.classList.toggle('k3lp-selected', offer.querySelector('input').checked));
    const add = root.querySelector('.k3lp-add');
    if (checked && add) {
      // INT-509: "Get My Kit — <s>compare</s> price" of the chosen option (data-cta), as on the other kit pages.
      add.innerHTML = checked.dataset.cta;
      add.dataset.sellingPlan = checked.dataset.sellingPlan || '';
      const unavailable = !add.dataset.variantId || (checked.value !== 'once' && !add.dataset.sellingPlan);
      add.disabled = unavailable;
      // Run 10: Kira asked for the "not available to purchase yet" line removed entirely; keep the note empty and hidden.
      const note = root.querySelector('.k3lp-preview-note');
      if (note) { note.classList.add('k3lp-sr'); note.textContent = ''; }
    }
  };
  root.addEventListener('change', (event) => { if (event.target.matches('[name="k3lp-offer"]')) syncOffer(); });
  syncOffer();

  let busy = false;
  const addToCart = async (button) => {
    if (busy) return;
    const note = root.querySelector('.k3lp-preview-note');
    const variantId = button.dataset.variantId;
    if (!variantId || (root.querySelector('[name="k3lp-offer"]:checked')?.value !== 'once' && !button.dataset.sellingPlan)) {
      // Dev: variant_id / selling_plan_id not set in section settings yet.
      note.textContent = 'Checkout is not available yet. Please check back soon.';
      note.classList.remove('k3lp-sr');
      return;
    }
    busy = true; button.setAttribute('aria-busy', 'true'); button.disabled = true;
    const body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (button.dataset.sellingPlan) body.items[0].selling_plan = Number(button.dataset.sellingPlan);
    // INT-430: This button opens the store's standard side cart (cart-drawer) after adding, like product pages (desktop since
    // 10-15 morning; phones too since Raghuwant's 18:53Z follow-up).
    // Falls back to the cart page when the drawer is missing or cannot render.
    const drawer = document.querySelector('cart-drawer');
    const useDrawer = !!(drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function');
    if (useDrawer) { body.sections = drawer.getSectionsToRender().map((s) => s.id).join(','); body.sections_url = window.location.pathname; }
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
      if (!res.ok) throw new Error('cart');
      if (!useDrawer) { window.location.href = '/cart'; return; }
      const data = await res.json().catch(() => null);
      busy = false; button.removeAttribute('aria-busy'); button.disabled = false;
      try {
        if (!data || !data.sections) throw new Error('sections');
        drawer.setActiveElement(button);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'figma-lp-kit3', productVariantId: variantId, cartData: data }); } catch (err) {} }
        drawer.renderContents(data);
        drawer.classList.remove('is-empty');
      } catch (err) { window.location.href = '/cart'; }
    } catch (e) {
      note.textContent = 'Something went wrong adding the kit. Please try again.'; note.setAttribute('role', 'alert');
      busy = false; button.removeAttribute('aria-busy'); button.disabled = false;
    }
  };

  // Move FDA legal note into the theme footer's upper legal area (this page only)
  const legal = root.querySelector('[data-k3lp-legal]');
  const footerTop = document.querySelector('footer .footer__content-top') || document.querySelector('footer');
  if (legal && footerTop) { legal.classList.add('k3lp-legal--footer'); footerTop.insertBefore(legal, footerTop.firstChild); }

  // Scroll-lock guard (this page only).
  // The Alia popup app (theme app embed) mounts its modal a few seconds after load and writes
  // body.style.overflow = 'hidden' (on iOS 26 also position/inset on html + body) until the popup closes.
  // This page hides that popup with CSS, so it can never be closed and the lock would stay forever.
  // Release the lock only while no modal, drawer or popup is actually visible; a real open modal keeps it.
  const lockProps = ['overflow', 'position', 'inset'];
  const modalVisible = () => Array.from(document.querySelectorAll('[aria-modal="true"], [id^="alia-root"], cart-drawer, .menu-drawer, .ocu-popup'))
    .some(el => { const c = getComputedStyle(el); return c.display !== 'none' && c.visibility !== 'hidden' && el.getBoundingClientRect().height > 0; });
  const releaseLock = () => {
    if (modalVisible()) return;
    [document.body, document.documentElement].forEach(el => {
      if (el.style.overflow === 'hidden') lockProps.forEach(p => el.style.removeProperty(p));
    });
  };
  new MutationObserver(releaseLock).observe(document.body, { attributes: true, attributeFilter: ['style'] });
  new MutationObserver(releaseLock).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
  releaseLock();

  // Testimonial autoplay: advances every AUTO_MS; pauses while hovered/focused/hidden and for PAUSE_MS after any manual interaction.
  if (!reduced) {
    root.querySelectorAll('.k3lp-review-track').forEach(track => {
      // Pause only while the pointer is over a card (reading) or a control has keyboard focus.
      let hover = false, focus = false;
      track.addEventListener('mouseover', (e) => hover = !!e.target.closest('.k3lp-review'));
      track.addEventListener('mouseleave', () => hover = false);
      track.addEventListener('focusin', () => focus = true);
      track.addEventListener('focusout', () => focus = false);
      ['pointerdown', 'touchstart', 'keydown'].forEach(evt => track.addEventListener(evt, () => track.dataset.pauseUntil = String(Date.now() + PAUSE_MS), { passive: true }));
      track.setAttribute('tabindex', '0');
      track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') scrollTrack(track, 1); if (e.key === 'ArrowLeft') scrollTrack(track, -1); });
      setInterval(() => {
        if (hover || focus || document.hidden) return;
        if (Number(track.dataset.pauseUntil || 0) > Date.now()) return;
        if (!track.getClientRects().length) return;
        scrollTrack(track, 1);
      }, AUTO_MS);
    });
  }
})();

// INT-509: phone "Get My Kit" bar. It adds the selected option through the purchase-box button (same add, side cart and
// upsell popup), shows once the hero button has scrolled away, and hides while any page button is on screen (Afzal).
(() => {
 const root = document.querySelector('.k3lp-root');
 const buy = root?.querySelector('.k3lp-add');
 const heroCta = root?.querySelector('.k3lp-hero-cta');
 if (!buy || !heroCta || root.querySelector('.k3lp-sticky-cart')) return;
 const inlineCtas = [...root.querySelectorAll('.k3lp-cta')];
 const bar = document.createElement('div');
 bar.className = 'k3lp-sticky-cart'; bar.hidden = true;
 // An <a>, as before, so the existing sticky-bar styles (a.k3lp-cta) still apply, but with no href, so it never jumps.
 // data-k3lp-sticky-add names it to the upsell app (snippets/oneclickupsellapp-extend.liquid), which ignores .click().
 const button = document.createElement('a');
 button.className = 'k3lp-cta'; button.tabIndex = 0; button.setAttribute('role', 'button');
 button.setAttribute('data-k3lp-sticky-add', '');
 button.textContent = 'Get My Kit';
 bar.append(button); root.append(bar);
 const sync = () => {
   const previewBar = document.querySelector('#preview-bar-iframe');
   const rect = previewBar?.getBoundingClientRect();
   const offset = rect && rect.height > 0 && rect.height < 160 && rect.bottom >= innerHeight - 2 ? rect.height : 0;
   bar.style.bottom = `${offset}px`;
   const inlineVisible = inlineCtas.some((e) => { const r = e.getBoundingClientRect(); return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight; });
   bar.hidden = !matchMedia('(max-width:749px)').matches || heroCta.getBoundingClientRect().bottom > 0 || inlineVisible;
 };
 button.addEventListener('click', (event) => {
   event.preventDefault();
   if (!buy.disabled) { buy.click(); return; }
   root.querySelector('#k3lp-buy')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
 });
 let queued = false;
 addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(() => {sync(); queued=false;}); } }, {passive:true});
 addEventListener('resize', sync); sync();
})();

// INT-430: the header cart icon opens the store's standard side cart (falls back to the cart page) and shows the cart count.
(() => {
  const root = document.querySelector('.k3lp-root');
  if (!root) return;
  const setCount = (n) => root.querySelectorAll('[data-lp-cart-count]').forEach((el) => { el.textContent = String(n); el.hidden = !(n > 0); });
  const refresh = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => setCount(c.item_count)).catch(() => {});
  // Closing the side cart hands focus back to the icon that opened it while the page is still locked, and at that moment the
  // sticky header sits at its unstuck spot at the very top, so a plain focus() jumped the page to the top. Focus without scrolling.
  const patched = new WeakSet();
  const focusWithoutScroll = (el) => {
    if (patched.has(el)) return;
    patched.add(el);
    const focus = el.focus;
    el.focus = function (options) { return focus.call(this, Object.assign({}, options, { preventScroll: true })); };
  };
  root.addEventListener('click', (event) => {
    const link = event.target.closest('[data-lp-cart-open]');
    if (!link) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    focusWithoutScroll(link);
    drawer.open(link);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { try { subscribe(PUB_SUB_EVENTS.cartUpdate, refresh); } catch (e) {} }
})();
